module.exports = __webpack_public_path__ + "img/petstairs48.a5efa498.jpg";